var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewManagmentIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-options",
    "data-name": "Icon ionic-md-options",
    transform: "translate(-2.25 -2.25)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803",
    transform: "translate(2.25 10.607)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3626",
    "data-name": "Path 3626",
    d: "M2.25,27h7.893v.929H2.25Z",
    transform: "translate(-2.25 -25.143)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3627",
    "data-name": "Path 3627",
    d: "M28.125,27h2.321v.929H28.125Z",
    transform: "translate(-17.446 -25.143)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3628",
    "data-name": "Path 3628",
    d: "M24.357,26.2a.936.936,0,0,1-.929.943h0A.936.936,0,0,1,22.5,26.2V23.443a.936.936,0,0,1,.929-.943h0a.936.936,0,0,1,.929.943Z",
    transform: "translate(-14.143 -22.5)",
    fill: "currentColor"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804",
    transform: "translate(2.25 6.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3629",
    "data-name": "Path 3629",
    d: "M2.25,16.875H4.571V17.8H2.25Z",
    transform: "translate(-2.25 -15.018)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3630",
    "data-name": "Path 3630",
    d: "M14.625,16.875h7.893V17.8H14.625Z",
    transform: "translate(-9.518 -15.018)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3631",
    "data-name": "Path 3631",
    d: "M10.857,16.075a.936.936,0,0,1-.929.943h0A.936.936,0,0,1,9,16.075V13.318a.936.936,0,0,1,.929-.943h0a.936.936,0,0,1,.929.943Z",
    transform: "translate(-6.214 -12.375)",
    fill: "currentColor"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    transform: "translate(2.25 2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3632",
    "data-name": "Path 3632",
    d: "M2.25,6.75h7.893v.929H2.25Z",
    transform: "translate(-2.25 -4.893)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3633",
    "data-name": "Path 3633",
    d: "M28.125,6.75h2.321v.929H28.125Z",
    transform: "translate(-17.446 -4.893)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3634",
    "data-name": "Path 3634",
    d: "M24.357,5.95a.936.936,0,0,1-.929.943h0A.936.936,0,0,1,22.5,5.95V3.193a.936.936,0,0,1,.929-.943h0a.936.936,0,0,1,.929.943Z",
    transform: "translate(-14.143 -2.25)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewManagmentIco);
export default __webpack_public_path__ + "static/media/new-managment-ico.7ad86e00.svg";
export { ForwardRef as ReactComponent };